function StoryFooter() {
  return (
    <div className="StoryFooter">
      <div className="Container">
        <p>
          Would you like to become a fingy climber too? We might help you get a
          bit closer.
        </p>
        <a
          href={process.env.NEXT_PUBLIC_APPSTORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="Button Button--hero"
        >
          <span className="Button__content">Get Fingy App</span>
        </a>
      </div>
    </div>
  );
}

export default StoryFooter;
